export const plans = {
    free: {
        fees: {
            "0-50": 0.02,
            "51-400": 0.018,
            "401-1000": 0.015,
            "1001-5000": 0.011,
            "5001-10000": 0.01,
            "10001-Infinity": 0.008
        },
        features: [
            "All features available",
            "No recurring charges",
        ],
        promoString: "Pay as you go"
    },
    // business: {
    //     fees: {
    //         "0-50": 0,
    //         "51-400": 0.018,
    //         "401-1000": 0.015,
    //         "1001-10000": 0.011,
    //         "10001-Infinity": 0.008
    //     },
    //     features: [
    //         "All features available",
    //         "50 free orders included"
    //     ],
    //     promoString: "Growing stronger"
    // },
    enterprise: {
        fees: null,
        features: [
            "All features available",
            "Meet the specific needs of business"
        ],
        promoString: "For specific needs"
    }
}